import { render, staticRenderFns } from "./AuthChooseItem.vue?vue&type=template&id=384464af&scoped=true"
import script from "./AuthChooseItem.vue?vue&type=script&lang=js"
export * from "./AuthChooseItem.vue?vue&type=script&lang=js"
import style0 from "./AuthChooseItem.vue?vue&type=style&index=0&id=384464af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384464af",
  null
  
)

export default component.exports